/** @format */

import handleInputError from './handle_input_error';
import {useEmailList} from './use_email_list';
import handleError from './handle_error';
import {If} from 'frontier-utilities';
import React from 'react';

// styles
import './comama_separated_input.scss';

const CommaSeparatedInput = props => {
    const {
        placeholder = '',
        separator = ',',
        errorMessage,
        value = '',
        onKeyDown,
        className,
        onChange,
        hasError,
        newestds,
        label,
        ...rest
    } = props;

    const {
        handleKeyDown,
        handleDelete,
        handleChange,
        isValidEmail,
        inputValue,
        handleBlur,
        inputRef,
        items
    } = useEmailList({value, separator, onKeyDown, onChange});

    return (
        <div className={`comma-separated-input-57wl ${hasError ? 'is-invalid' : ''}`}>
            <If condition={!!label && !!inputValue}>
                <label>
                    <span>{label}</span>
                </label>
            </If>
            <div className="tag-input-container">
                {items.map((item, index) => (
                    <div key={index} className="tag">
                        <span>{item}</span>
                        <button onClick={() => handleDelete(index)}>x</button>
                    </div>
                ))}
                <input
                    className={isValidEmail ? '' : 'is-invalid-entry'}
                    placeholder={placeholder}
                    onKeyDown={handleKeyDown}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={inputValue}
                    ref={inputRef}
                    type="text"
                    {...rest}
                />
            </div>
            <If condition={hasError}>
                <div style={{fontSize: '.9em', color: 'red', display: 'block'}}>{errorMessage}</div>
            </If>
        </div>
    );
};

export default handleError(handleInputError(CommaSeparatedInput));
